var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthGuard } from '@app/shared/common/IDSVRAuthProviders/auth.guard.service';
import { ClaimModifyServiceProxy, HealthCareApiServiceProxy } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { HraAssessmentBaseComponent } from '../hra-assessment-base/hra-assessment-base.component';
var HraAssessmentComponent = /** @class */ (function (_super) {
    __extends(HraAssessmentComponent, _super);
    function HraAssessmentComponent(route, router, injector, authGuard, claimService, healthCareService, claimModifyService) {
        var _this = _super.call(this, injector, authGuard, claimService, healthCareService, claimModifyService) || this;
        _this.route = route;
        _this.router = router;
        return _this;
    }
    HraAssessmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        abp.ui.setBusy();
        this.updateClaimsIdsvr().then(function () {
            _this.questionnaireKey = _this.route.snapshot.params.questionnaireKey;
            _this.defaultValues = {
                gender: _this._authService.user.profile['gender'],
                age: moment(moment()).diff(moment(_this._authService.user.profile['birthdate'], 'DD/MM/YYYY hh:mm:ss A'), 'years')
            };
            _this.setQuestionnaire().then(function () {
                abp.ui.clearBusy();
            });
        });
    };
    HraAssessmentComponent.prototype.submit = function (isCompleted) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isCompleted) {
                            this.isSubmitting = true;
                        }
                        else {
                            this.isSaving = true;
                        }
                        return [4 /*yield*/, _super.prototype.submit.call(this, isCompleted)];
                    case 1:
                        _a.sent();
                        this.isSubmitting = this.isSaving = false;
                        this.router.navigateByUrl('/app/main/MyHealthCare/RiskAssessment');
                        return [2 /*return*/];
                }
            });
        });
    };
    HraAssessmentComponent.prototype.breadcrumbNavigation = function (link) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        abp.ui.setBusy();
                        return [4 /*yield*/, _super.prototype.submit.call(this, false)];
                    case 1:
                        _a.sent();
                        abp.ui.clearBusy();
                        this.router.navigateByUrl(link);
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(HraAssessmentComponent.prototype, "answeredQuestionDescription", {
        get: function () {
            var e_1, _a, e_2, _b;
            var shownCount = 0;
            var answeredCount = 0;
            try {
                for (var _c = __values(this.currentQuestionnaire.phases.filter(function (p) { return p.isVisible; })), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var phase = _d.value;
                    try {
                        for (var _e = __values(phase.questions.filter(function (q) { return q.isVisible; })), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var question = _f.value;
                            shownCount++;
                            if (question.answersGiven.length > 0) {
                                answeredCount++;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return answeredCount + " / " + shownCount;
        },
        enumerable: true,
        configurable: true
    });
    return HraAssessmentComponent;
}(HraAssessmentBaseComponent));
export { HraAssessmentComponent };
